import { ActivityItem, Icon, Link, mergeStyleSets } from "@fluentui/react";
import { FunctionComponent } from "react";

const classNames = mergeStyleSets({
  exampleRoot: {
    marginTop: "20px",
  },
  nameText: {
    fontWeight: "bold",
  },
});

interface JerarquiaControlesVistaProps {
  TareaId: string;
}

const JerarquiaControlesVista: FunctionComponent<
  JerarquiaControlesVistaProps
> = () => {

  const activityItemExamples = [
    {
      key: 1,
      activityDescription: [
        <Link key={1} className={classNames.nameText}>
          EPP
        </Link>,
      ],
      activityIcon: <Icon iconName={"CRMServices"} />,
      comments: [
        <span key={1}>EPP según estándar </span>,
        <Icon iconName={"edit"} style={{ cursor: "pointer", marginLeft: 5 }} />,
      ],
      timeStamp: ".",
    },
    {
      key: 2,
      activityDescription: [
        <Link key={1} className={classNames.nameText}>
          Control Administrativo
        </Link>,
      ],
      comments: [
        <span key={1}>
          OTE, IPERCc, PETS, señalización, inspeccion, capacitación,
          tratamiento, cartilla de respuesta de emergencia, regla de oro por la
          via
        </span>,
        <Icon iconName={"edit"} style={{ cursor: "pointer", marginLeft: 5 }} />,
      ],
      activityIcon: <Icon iconName={"D365TalentHRCore"} />,
      timeStamp: ".\n",
    },
    {
      key: 3,
      activityDescription: [
        <Link
          key={1}
          className={classNames.nameText}
          onClick={() => {
            alert("A name was clicked.");
          }}
        >
          Controles de Ingeniería
        </Link>,
      ],
      comments: [
        <span key={1}>
          Ilumunaciòn artifical ( Reflectores y lamparas de emergencia)
        </span>,
        <Icon iconName={"edit"} style={{ cursor: "pointer", marginLeft: 5 }} />,
      ],
      activityIcon: <Icon iconName={"PlayerSettings"} />,
      timeStamp: ".",
    },
    {
      key: 4,
      activityDescription: [
        <Link
          key={1}
          className={classNames.nameText}
          onClick={() => {
            alert("A name was clicked.");
          }}
        >
          Sustitución
        </Link>,
      ],
      comments: [
        <span key={1}>Sustitución</span>,
        <Icon iconName={"edit"} style={{ cursor: "pointer", marginLeft: 5 }} />,
      ],
      activityIcon: <Icon iconName={"RemoveOccurrence"} />,
      timeStamp: ".",
    },
    {
      key: 5,
      activityDescription: [
        <Link
          key={1}
          className={classNames.nameText}
          onClick={() => {
            alert("A name was clicked.");
          }}
        >
          Eliminación
        </Link>,
      ],
      comments: [
        <span key={1}>Eliminación</span>,
        <Icon iconName={"edit"} style={{ cursor: "pointer", marginLeft: 5 }} />,
      ],
      activityIcon: <Icon iconName={"ReceiptUndelivered"} />,
      timeStamp: ".",
    },
  ];
  
  return (
    <>
      <span key={1}>Riego : Caída al mismo nivel</span>
      <br />
      <div>
        {activityItemExamples.map((item: { key: string | number }) => (
          <>
            <br />
            <ActivityItem
              {...item}
              key={item.key}
              // className={classNames.exampleRoot}
            />
          </>
        ))}
      </div>
    </>
  );
};

export default JerarquiaControlesVista;
